import React from 'react';
import PropTypes from 'prop-types';
import { usePropertyCardLogic } from './PropertyCardLogic';
import Card from '../../layout/Card/Card';
import FormRow from '../../form/FormRow/FormRow';
import FormColumn from '../../form/FormColumn/FormColumn';
import SelectField from '../../form/SelectField/SelectField';
import TextDisplay from '../../form/TextDisplay/TextDisplay';
import styles from './PropertyCard.module.css';

const PropertyCard = ({ setPropertyData, isMRV }) => {
  const {
    isLoading,
    cities,
    properties,
    units,
    selectedCity,
    selectedProperty,
    selectedUnit,
    propertyValue,
    priceTableVersion,
    address,
    handleCityChange,
    handlePropertyChange,
    handleUnitChange
  } = usePropertyCardLogic(setPropertyData, isMRV);

  return (
    <div className={styles.propertyCardContainer}>
      {isLoading && (
        <div className={styles.loadingOverlay}>
          <div className={styles.spinnerContainer}>
            <div className={styles.spinner}></div>
            <div className={styles.loadingText}>Carregando dados...</div>
          </div>
        </div>
      )}

      <Card title="Informações do Imóvel">
        <FormRow>
          <FormColumn cols={4}>
            <SelectField
              id="cidade"
              label="Cidades"
              value={selectedCity}
              onChange={handleCityChange}
              options={cities}
              disabled={isLoading}
            />
          </FormColumn>
          <FormColumn cols={4}>
            <SelectField
              id="empreendimento"
              label="Empreendimento"
              value={selectedProperty}
              onChange={handlePropertyChange}
              options={properties}
              disabled={isLoading}
            />
          </FormColumn>
          <FormColumn cols={4}>
            <SelectField
              id="unidade"
              label="Unidade"
              value={selectedUnit}
              onChange={handleUnitChange}
              options={units}
              disabled={isLoading}
            />
          </FormColumn>
        </FormRow>
        <FormRow>
          <FormColumn cols={6} >
            <TextDisplay
              id="endereco"
              label="Endereço"
              value={address}
            />
          </FormColumn>
          <FormColumn cols={3}>
            <TextDisplay
              id="valorImovelComDelta"
              label="Valor do Imóvel"
              value={propertyValue}
            />
          </FormColumn>
          <FormColumn cols={3}>
            <TextDisplay
              id="versaoTabelaPrecos"
              label="Versão Tabela Preços"
              value={priceTableVersion}
            />
          </FormColumn>
          
        </FormRow>
      </Card>
    </div>
  );
};

PropertyCard.propTypes = {
  setPropertyData: PropTypes.func.isRequired,
  isMRV: PropTypes.bool.isRequired,
};

export default PropertyCard;